export default "__VITE_ASSET__B0te$9ac__"